module.exports = __webpack_public_path__ + "img/replay-button.940be608.png";